enum CountryCodes{
  CA = "CA",
  US = "US",
  AU = "AU",
}

export default CountryCodes
